import React from "react";

// ════════════════════════════════════════════════════════════════
//  Regio-info: vliegveld, glasvezel en NL/expat-gemeenschap.
//  Indicatief, stand juni 2026 — geen live data. Glasvezel/vluchten
//  en gemeenschapsdichtheid wijzigen; verifieer per adres/seizoen.
// ════════════════════════════════════════════════════════════════
const REGIO = {
  "Silver Coast": { air:"Lissabon (LIS)", flights:"Dagelijks NL↔Lissabon (KLM, TAP, Transavia).", fiber:"FTTH-glasvezel vrijwel overal in de dorpen (MEO/NOS/Vodafone).", comm:"Groeiende NL/UK-gemeenschap rond Ericeira, Caldas da Rainha/Óbidos en Foz do Arelho." },
  "Alentejo Coast": { air:"Lissabon (LIS) of Faro (FAO) — beide ~1,5–2u", flights:"Via Lissabon dagelijks; Faro vooral seizoen.", fiber:"FTTH in de dorpskernen; in buitengebied/quintas wisselend — check per adres.", comm:"Sterke NL/DE/BE-gemeenschap rond Vila Nova de Milfontes, Zambujeira do Mar en Odemira." },
  "Western Algarve": { air:"Faro (FAO) ~1–1,5u", flights:"Faro heeft veel directe NL-vluchten; zomerpiek.", fiber:"FTTH goed in de dorpen.", comm:"Internationale/expat-hub: Aljezur, Lagos, Sagres — sterke alternatieve/surf-scene." },
  "Eastern Algarve": { air:"Faro (FAO) 15–40 min", flights:"Faro dichtbij, veel NL-verbindingen.", fiber:"FTTH goed.", comm:"Expat-hub Tavira/Olhão; rustiger en authentieker dan centraal-Algarve." },
  "Setúbal/Arrábida": { air:"Lissabon (LIS) ~50 min", flights:"Dagelijks NL↔Lissabon.", fiber:"Stedelijk FTTH uitstekend.", comm:"Gemengd Portugees/expat; korte lijn met Lissabon." },
  "Costa Verde": { air:"Porto (OPO) 45 min–1,5u", flights:"Porto: dagelijks NL↔OPO (KLM, Transavia, Ryanair).", fiber:"FTTH goed in de steden.", comm:"Weinig NL-expats, authentiek Minho; koeler en groener — klimaat-bestendiger." },
  "Aveiro Coast": { air:"Porto (OPO) ~1u", flights:"Porto: dagelijkse NL-verbindingen.", fiber:"FTTH uitstekend (universiteitsstad Aveiro).", comm:"Internationaal studentenklimaat; weinig NL-gezinnen." },
};
export function RegioInfo({ town }) {
  const r = town && REGIO[town.region];
  if (!r) return null;
  const rows = [
    ["✈️","Vliegveld", town.distAirport ? `${town.distAirport} · ${r.air}` : r.air],
    ["🛫","Verbindingen NL", r.flights],
    ["🌐","Internet", r.fiber],
    ["👪","NL/expat-gemeenschap", r.comm],
  ];
  return (
    <section className="regio-section">
      <h4>📍 Regio-info — {town.region}</h4>
      <div className="regio-grid">
        {rows.map(([ic,lab,val],i)=>(
          <div key={i} className="regio-row">
            <span className="regio-ic">{ic}</span>
            <div><div className="regio-lab">{lab}</div><div className="regio-val">{val}</div></div>
          </div>
        ))}
      </div>
      <p className="regio-foot">Indicatief, stand juni 2026 — geen live data. Glasvezel, vluchtaanbod en gemeenschapsdichtheid wisselen per adres en seizoen.</p>
    </section>
  );
}
